import React from "react";
import { GameNotificationBotBlock } from "../../../src/server/models/game/modules/notifications/blocks";
import PlayerAvatar from "../../user/avatar";
import { BOT_AVATAR } from "@/src/models/game/bot";

type Props = {
    block: GameNotificationBotBlock;
}

const SIZE = '16px';

export default function NotificationBot(
    {
        block,
    }: Props,
): React.ReactNode {
    return <span style={{fontWeight: 'bold'}}>
        <PlayerAvatar
            src={BOT_AVATAR}
            style={{
                maxWidth: SIZE,
                maxHeight: SIZE,
            }}
        />
        &nbsp;
        {block.bot.name}
    </span>
}
